<template>
  <v-container class="py-8 px-8">
    <!-- Título principal -->
    <v-row align="center" justify="space-between" class="mb-4">
      <v-col cols="12" md="6">
        <div style="font-family: 'montserrat-bold'; font-size: 32px; color: black;">
          Dashboard de control
        </div>
        <div style="font-family: 'montserrat-semibold'; font-size: 14px;">
          Aquí puedes ver un resumen de la actividad reciente de divisas.
        </div>
      </v-col>

      <v-col cols="12" md="6" class="d-flex justify-end align-center">
        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="startDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startDate"
              :label="'Select Start Date'"
              prepend-inner-icon="mdi-calendar"
              hide-details
              rounded
              filled
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="startDate" color="black">
            <v-spacer></v-spacer>
            <v-btn
              text
              color="black"
              @click="$refs.dialog.save(startDate), getDashboard()"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <v-spacer class="mx-2" />
        <v-dialog
          ref="dialogEndDate"
          v-model="modal2"
          :return-value.sync="endDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              :label="'Select End Date'"
              prepend-inner-icon="mdi-calendar"
              hide-details
              rounded
              filled
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate" color="black">
            <v-spacer></v-spacer>
            <v-btn
              text
              color="black"
              @click="$refs.dialogEndDate.save(endDate), getDashboard()"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <!-- <v-menu
          v-model="menuStart"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startDate"
              label="Fecha inicio"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker v-model="startDate" @change="getDashboard" />
        </v-menu>

        <v-spacer class="mx-2" />

        <v-menu
          v-model="menuEnd"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              label="Fecha fin"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker v-model="endDate" @change="getDashboard" />
        </v-menu> -->
      </v-col>
    </v-row>


    <v-row class="mb-6 no-gutters">
      <!-- GMV principal -->
      <v-col cols="12" md="3">
        <v-card
          elevation="6"
          class="pa-6 text-center d-flex flex-column align-center justify-center white--text"
          style="
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
            height: 100%;
            background: linear-gradient(135deg, #1e3a8a, #3b82f6);
            margin-right: -1px; /* para unir sin espacio */
            z-index: 2;
          "
        >
          <v-icon large class="mb-2 white--text">mdi-cash-multiple</v-icon>
          <div style="font-family: 'montserrat-bold'; font-size: 24px;">${{ formatMoney(dashboard.gmv_total) }} USD</div>
          <div style="font-family: 'montserrat-bold';" class="white--text">GMV Total</div>
        </v-card>
      </v-col>

      <!-- Grupo de KPIs secundarios -->
      <v-col cols="12" md="6">
        <v-row no-gutters style="height: 100%;">
          <!-- Pendientes de cesión -->
          <v-col cols="4">
            <v-card
              outlined
              class="pa-4 text-center d-flex flex-column align-center justify-center"
              style="border-radius: 0; border-left: none; height: 100%;"
            >
              <div style="font-family: 'montserrat-bold'; font-size: 20px;" v-if="tiposOperacion">${{ formatMoney(getTotalByTypes(tiposOperacion.Spot)) }} USD</div>
              <div style="font-family: 'montserrat-bold';" class="grey--text text--darken-1">Spot</div>
            </v-card>
          </v-col>

          <!-- Por cobrar -->
          <v-col cols="4">
            <v-card
              outlined
              class="pa-4 text-center d-flex flex-column align-center justify-center"
              style="border-radius: 0; border-left: none; height: 100%;"
            >
              <div style="font-family: 'montserrat-bold'; font-size: 20px;" v-if="tiposOperacion">${{ formatMoney(getTotalByTypes(tiposOperacion.Forward)) }} USD</div>
              <div style="font-family: 'montserrat-bold';" class="grey--text text--darken-1">Forward</div>
            </v-card>
          </v-col>

          <!-- Monto financiado -->
          <v-col cols="4">
            <v-card
              outlined
              class="pa-4 text-center d-flex flex-column align-center justify-center"
              style="border-radius: 0; border-left: none; height: 100%;"
            >
              <div style="font-family: 'montserrat-bold'; font-size: 20px;" v-if="tiposOperacion">${{ formatMoney(getTotalByTypes(tiposOperacion.WindowSpot)) }} USD</div>
              <div style="font-family: 'montserrat-bold';" class="grey--text text--darken-1">Window Spot</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="3">
        <v-card
          elevation="6"
          class="pa-6 text-center d-flex flex-column align-center justify-center white--text"
          style="
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            height: 100%;
            background: linear-gradient(135deg, #1e3a8a, #3b82f6);
            margin-right: -1px; /* para unir sin espacio */
            z-index: 2;
          "
        >
          <v-icon large class="mb-2 white--text">mdi-cash-multiple</v-icon>
          <div style="font-family: 'montserrat-bold'; font-size: 24px;">${{ formatMoney(dashboard.revenue) }} USD</div>
          <div style="font-family: 'montserrat-bold';" class="white--text">Revenue Total</div>
        </v-card>
      </v-col>
    </v-row>


    <!-- Gráfica + uso de línea + deudores -->
    <v-row align="stretch" >
      <v-col cols="12" md="4" lg="4">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-card outlined class="pa-4 d-flex flex-column align-center justify-center" style="border-radius: 20px;" v-bind="attrs" v-on="on">
              <v-icon large color="black darken-2" class="mb-2">mdi-account-plus</v-icon>
              <div class="text-h5 font-weight-bold">{{ dashboard.cuentas_creadas }} nuevos</div>
              <div class="caption">Clientes en el periodo</div>
            </v-card>
          </template>
          <div v-if="dashboard.clientesNuevos && dashboard.clientesNuevos.length">
            <div v-for="(cliente, index) in dashboard.clientesNuevos" :key="index">{{ cliente.sName }}</div>
          </div>
          <div v-else>No hay clientes nuevos en este periodo</div>
        </v-tooltip>
      </v-col>

      <v-col cols="12" md="4" lg="4">
        <v-card outlined class="pa-4 d-flex flex-column align-center justify-center" style="border-radius: 20px;">
          <v-icon large color="black darken-2" class="mb-2">mdi-cash-plus</v-icon>
          <div class="text-h5 font-weight-bold">{{ dashboard.pagos_generados }} pago</div>
          <div class="caption">Pagos realizados</div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4" lg="4">
        <v-card outlined class="pa-4 d-flex flex-column align-center justify-center" style="border-radius: 20px;">
          <v-icon large color="black darken-2" class="mb-2">mdi-cash-sync</v-icon>
          <div class="text-h5 font-weight-bold">{{ dashboard.conversions_generados }} conversion</div>
          <div class="caption">Conversiones realizadas</div>
        </v-card>
      </v-col>

      <v-col cols="6" md="6" lg="6">
        <v-card outlined class="pa-4" style="border-radius: 20px; height: fit-content; overflow-y: auto;">
          <div class="text-subtitle-1 font-weight-bold mb-4 text-center">
            Top clientes por volumen
          </div>
          <v-data-table :items-per-page="5" hide-default-header :items="dashboard.clientesDetalle" style="background-color: white !important">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">{{ "Cliente" }}</th>   
                  <th class="header__title center">{{ "Total" }}</th>                                                                                                                                                                                 
                  <th class="header__title center">{{ "Spot" }}</th>                                                                                                                                                                                                                     
                  <th class="header__title center">{{ "Forward" }}</th>
                  <th class="header__title center">{{ "Window" }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="cliente in dashboard.clientesDetalle" :key="cliente.sEnterpriseId">
                  <td class="table__item">{{ cliente.sName }}</td>
                  <td class="table__item">${{ formatMoney(cliente.total_usd) }} USD</td>
                  <td class="table__item">
                    <span v-if="cliente.spot">${{ formatMoney(cliente.spot) }} USD </span>
                    <span v-else>-</span>
                  </td>
                  <td class="table__item">
                    <span v-if="cliente.forward">${{ formatMoney(cliente.forward) }} USD </span>
                    <span v-else>-</span>
                  </td>
                  <td class="table__item">
                    <span v-if="cliente.window_spot">${{ formatMoney(cliente.window_spot) }} USD </span>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="6" md="6" lg="6">
        <v-card outlined class="pa-4" style="border-radius: 20px; height: fit-content; overflow-y: auto;">
          <div class="text-subtitle-1 font-weight-bold mb-4 text-center">
            Top clientes por revenue
          </div>
          <v-data-table :items-per-page="5" hide-default-header :items="dashboard.clientesDetalle" style="background-color: white !important">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">{{ "Cliente" }}</th>   
                  <th class="header__title right">{{ "Revenue" }}</th> 
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="cliente in clientesOrdenadosPorRevenue" :key="cliente.sEnterpriseId">
                  <td class="table__item">{{ cliente.sName }}</td>
                  <td class="table__item">${{ formatMoney(cliente.revenue) }} USD</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- <v-row align="stretch" >
      <v-col cols="12" md="6" lg="6">
        <v-card class="pa-4 fill-height" style="border-radius: 20px;">
          <div style="font-family: 'montserrat-bold'; font-size: 16px; text-align: center;" class="mb-2">GMV</div>
          <LineChart :labels="dashboard.chartLabels" :data="dashboard.chartData" />
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="6">
        <v-card class="pa-4 fill-height" style="border-radius: 20px;">
          <div style="font-family: 'montserrat-bold'; font-size: 16px; text-align: center;" class="mb-2">Revenue</div>
          <LineChart :labels="dashboard.chartLabelsRevenue" :data="dashboard.chartDataRevenue" />
        </v-card>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import LineChart from '@/components/LineChart.vue'
import moment from 'moment'

export default {
  components: {
    LineChart
  },
  data() {
    return {
      menuStart: false,
      modal: false,
      modal2: false,
      menuEnd: false,
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD'),
      dashboard: [],
      tiposOperacion: {
        Spot: ['e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a', 'ea9d350f-f00b-4763-90db-72e7af54dc73'],
        Forward: ['b80e8dc6-4138-449e-8903-968efb8437b3'],
        WindowSpot: ['484a23d2-7dc1-4fd0-a1b0-3402d066c2cf']
      }
    }
  },
  computed: {
    clientesOrdenadosPorRevenue() {
      if (!this.dashboard?.clientesDetalle) return [];

      return [...this.dashboard.clientesDetalle]
        .sort((a, b) => Number(b.revenue) - Number(a.revenue));
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MMMM D, YYYY');
    },
    async getDashboard() {
      try {
        const startDate = this.startDate + "T00:00:00-06:00";
        const endDate = this.endDate + "T23:59:59-06:00";

        const response = await DB.get(`${URI}/api/v1/en/administrator/dashboard`, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
          },
          params: {
            startDate,
            endDate
          }
        });

        this.dashboard = response.data.data;
      } catch (err) {
        console.error(err);
      }
    },
    getTotalByTypes(uuids) {
      return this.dashboard.operaciones
        .filter(op => uuids.includes(op.sTransactionType))
        .reduce((sum, op) => sum + parseFloat(op.total || 0), 0)
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value)
    }
  },
  beforeMount() {
    this.getDashboard();
  }
}
</script>

<style scoped>
.gradient-card {
  background: linear-gradient(to bottom, #333, #000);
  border-radius: 12px;
  color: white;
}
</style>
